import { createFileRoute } from '@tanstack/react-router';
import { QuickQuoteLanding } from '../../components/QuickQuoteLanding';

export const Route = createFileRoute('/quickquote/')({
  component: QuickQuoteLanding,
});
